import { render, staticRenderFns } from "./evaluationPage.vue?vue&type=template&id=0b3d4c41&scoped=true"
import script from "./evaluationPage.vue?vue&type=script&lang=js"
export * from "./evaluationPage.vue?vue&type=script&lang=js"
import style0 from "./evaluationPage.vue?vue&type=style&index=0&id=0b3d4c41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d4c41",
  null
  
)

export default component.exports